/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ExternalIdDTO
 */
export interface ExternalIdDTO  {
    /**
     * 
     * @type {number}
     * @memberof ExternalIdDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalIdDTO
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalIdDTO
     */
    type?: string;
}

/**
 * Check if a given object implements the ExternalIdDTO interface.
 */
export function instanceOfExternalIdDTO(value: object): value is ExternalIdDTO {
    return true;
}

export function ExternalIdDTOFromJSON(json: any): ExternalIdDTO {
    return ExternalIdDTOFromJSONTyped(json, false);
}

export function ExternalIdDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalIdDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'externalId': json['externalId'] == null ? undefined : json['externalId'],
                  'type': json['type'] == null ? undefined : json['type'],
    };
}

export function ExternalIdDTOToJSON(json: any): ExternalIdDTO {
    return ExternalIdDTOToJSONTyped(json, false);
}

export function ExternalIdDTOToJSONTyped(value?: ExternalIdDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'externalId': value['externalId'],
        'type': value['type'],
    };
}


